const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAILURE = 'LOGIN_FAILURE'
const LOGOUT = 'LOGOUT'
const CHANGE_FILTER = 'CHANGE_FILTER'
const LOAD_DATA = 'LOAD_DATA'
const CLEAR = 'CLEAR'
const QUERY = 'QUERY'
const SET_GIVE_UP_COMMENTS = 'SET_GIVE_UP_COMMENTS';

export {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  CHANGE_FILTER,
  LOAD_DATA,
  CLEAR,
  QUERY,
  SET_GIVE_UP_COMMENTS
}



// WEBPACK FOOTER //
// ./src/reducks/reports/types.js